import fetchRetry from "fetch-retry";

export default {
  postS3Image(url, data) {
    // 500, 503 がもどってきた場合は、10回リトライする
    // ref: https://docs.aws.amazon.com/ja_jp/general/latest/gr/api-retries.html

    return fetchRetry(url, {
      retries: 10,
      retryDelay: 100,
      retryOn: [500, 503],
      method: "PUT",
      body: data
    });
  }
};
